import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  @Input() handler: BehaviorSubject<boolean> = this.loaderService.isLoading;
  constructor(
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.handler.subscribe((val) => {
      this.cdr.detectChanges();
    })
  }
}
